export default "__VITE_ASSET__MTj7B$TJ__"